<template>
	<el-dialog :title="'通过并创建studio用户(' + usernum + ')个'" width="50%" :visible.sync="dialogTableVisibles" append-to-body>
		<div style="width: 100%;height: 500px;overflow-y: auto;">
			<div style="display: flex;align-items: center;" v-for="(item,i) in studio" :key="i">
				<el-form inline>
					<el-form-item label="用户ID">
						<el-input placeholder="请输入" v-model="item.userid" style="width: 300px;"></el-input>
					</el-form-item>
					<el-form-item label="用户初始密码">
						<el-input placeholder="请输入" v-model="item.password" style="width: 300px;"></el-input>
					</el-form-item>
				</el-form>
	<!-- 			<div style="width: 35%;margin-bottom: 20px;display: flex;align-items: center;margin-left: auto;">
					用户专属团队ID:
					<el-input placeholder="请输入" style="width: 60%;" v-model="item.teamid"></el-input>
				</div> -->
			</div>
			
			<div style="border-top: 1px solid #ececec;margin-top: 30px;padding-top: 20px;">
				<el-form inline>
					<el-form-item label="团队ID">
						<el-input placeholder="请输入" v-model="teamid" style="width: 300px;"></el-input>
					</el-form-item>
					<el-form-item label="团队名称">
						<el-input placeholder="请输入" v-model="teamname" style="width: 300px;"></el-input>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<el-button type="primary" @click="admin_shenhe_gong">通过并创建</el-button>
	</el-dialog>
</template>

<script>
	import { admin_shenhe_gong } from "@/api/huanjing"
	export default {
		data(){
			return{
				dialogTableVisibles:false,
				status:2,
				id:'',
				usernum:1,
				
				studio:[],
				teamid:'',//团队id
				teamname:'',//团队名称
			}
		},
		watch:{
			dialogTableVisibles(e){
				if(e==false){
					this.status=2
					this.id = ''
					this.usernum = 1
					this.studio = []
				}
			},
		},
		methods:{
			admin_shenhe_gong(){
				let studio = this.studio;
				let is = 1;
				studio.forEach(r=>{
					if(!r.userid || !r.password){
						is = 0;
					}
				})
				if(is==0){
					this.$message.error("请完善信息");
					return;
				}
				if(!this.teamid || !this.teamname){
					this.$message.error("团队id和团队名称不能为空");
					return;
				}
				
				const loading = this.$loading({
				  lock: true,
				  text: '操作中',
				  spinner: 'el-icon-loading',
				  background: 'rgba(0, 0, 0, 0.7)'
				});
				admin_shenhe_gong({
					id:this.id,
					status:2,
					studio:this.studio,
					teamid:this.teamid,
					teamname:this.teamname
				}).then(()=>{
					loading.close();
					this.$message.success("成功");
					this.dialogTableVisibles = false
					this.$emit("succss");
				}).catch(()=>{
					loading.close();
				})
			},
			handle(status,row){
				this.id = row.id
				this.usernum = row.usernum
				this.dialogTableVisibles = true
				for(let i =0;i<row.usernum;i++){
					let rs = {};
					rs["userid"] = "";
					rs["password"] = "";
					rs["teamid"] = "";
					this.studio.push(rs);
				}

			},
		}
	}
</script>

<style  lang="scss">

</style>


// WEBPACK FOOTER //
// src/views/luntan/neirong/components/studio.vue